import { MEDIA_BASE_URL } from "./apiConfig";
export const CORRECT_SOUND_URL = MEDIA_BASE_URL + "/sound/54562b32-73e6-44c6-b5bf-eb5c9d253865.mp3";

export const FIRST_INCORRECT_SOUND_URL = MEDIA_BASE_URL + "/sound/fa470ba6-e3fb-4265-bb2f-4bdbeb24f945.mp3";

export const LAST_INCORRECT_SOUND_URL = MEDIA_BASE_URL + "/sound/18178f23-562b-46fc-ab07-639d1edbdc06.mp3";

export const LAST_QUESTION_OF_SUBJECT_SOUND_URL = MEDIA_BASE_URL + "/sound/dbb574ed-d2fe-4ff4-bb25-817dbfcf8ff1.mp3";

export const UNSCREAMBLE_SOUND_URL = MEDIA_BASE_URL + "/sound/c6ba3cdf-8c8d-48fb-96f0-5721f8fc5f83.mp3";

export const MATCH_SOUND_URL = MEDIA_BASE_URL + "/sound/d3b29669-b47a-4cd7-90fe-ccd6a718ef38.mp3";

export const CHOOICE_AND_SENTENCE_SOUND_URL = MEDIA_BASE_URL + "/sound/a70ba702-c702-4f15-97dc-a98496016954.mp3";


